module.exports = __webpack_public_path__ + "static/media/open_bower_ios.d1ba8570.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/open_bower_ios.png
// module id = 322
// module chunks = 0